import * as navigation from 'Navigation';

/**
 * @deprecated Use ReviewHistoryTabState.
 */
class ReviewTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Review',
      closeable: false,
      options: false,
      preferenceKey: 'review',
    };
  }
}

export default ReviewTabState;
